import Button from 'components/_UI/Button';
import Fieldset from 'components/_UI/Fieldset';
import Text from 'components/_UI/Text';
import { useStepRegister } from 'context/login/StepRegister';
import React, { useState } from 'react'
import { Column } from 'styled/alignment/Column';
import { StyledForm } from 'styled/UI/StyledForm';
import colors from 'theme/colors';
import sizes from 'theme/sizes';
import userApi from 'api/requests/user';
import { useUser } from 'context/user/User';
import { FullyCentered } from 'styled/alignment/Center';
import { useForm } from 'react-hook-form';
import fieldValidations from 'helpers/fieldValidations';
import { HorizontalCenter } from 'styled/alignment/Center';
import Loader from 'components/_UI/Loader';
import fieldMessages from 'texts/messages/field';
import buttonText from 'texts/buttons/buttonText';
import step from 'helpers/system/step';

function RegisterStepThree() {
    const { stepRegister, setStepRegister } = useStepRegister();
    const { user, setUser } = useUser();

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        defaultValues: {
            username: user.username || '',
            password: user.password || ''
        }
    });

    const [errorMessage, setErrorMessage] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const mountPayload = ({ username, password }) => {
        const payload = {
            ...user,
            username,
            password,
            is_commercial: false,
        }

        setUser(payload);

        return payload;
    };

    const registerUser = async ({ username, password, confirmPassword }) => {
        if (password !== confirmPassword) {
            setErrorMessage(fieldMessages.passwordMustBeEqual);
            
            return;
        }

        const payload = mountPayload({ username, password });

        setIsLoading(true);

        try {
            await userApi.create(payload);
            setStepRegister(step.next(stepRegister));
        } catch (error) {
            setErrorMessage(fieldMessages.generic);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Column fullyCentralized>
                <Text color={colors.neutral} type='bold' name='highlight'>
                    Já estamos terminando!
                </Text>
            </Column>

            <StyledForm
                marginTop={sizes.normal}
                paddingRight='13%'
                paddingLeft='13%'
                onSubmit={handleSubmit(registerUser)}
            >
                <Fieldset
                    placeholder='Nome de usuário'
                    layout='straight-center'
                    marginTop={sizes.normal}
                    name='username'
                    register={register}
                    validations={fieldValidations.name('usuário')}
                />

                {
                    errors.username?.message && (
                        <HorizontalCenter>
                            <Text color={colors.danger}> {errors.username?.message} </Text>
                        </HorizontalCenter>
                    )
                }

                <Fieldset
                    placeholder='Senha'
                    layout='straight-center'
                    marginTop={sizes.normal}
                    inputType='password'
                    name='password'
                    register={register}
                    validations={fieldValidations.password()}
                />
                {
                    errors.password?.message && (
                        <FullyCentered textAlign='center'>
                            <Text color={colors.danger}> {errors.password?.message} </Text>
                        </FullyCentered>
                    )
                }

                <Fieldset
                    placeholder='Confirme sua senha'
                    layout='straight-center'
                    marginTop={sizes.normal}
                    inputType='password'
                    name='confirmPassword'
                    register={register}
                    validations={fieldValidations.password()}
                />
                {
                    errors.confirmPassword?.message && (
                        <FullyCentered textAlign='center'>
                            <Text color={colors.danger}> {errors.confirmPassword?.message} </Text>
                        </FullyCentered>
                    )
                }

                <FullyCentered marginTop={sizes.micro}>
                    <Text
                        color={colors.danger}
                        type='bold'
                    >
                        {errorMessage}
                    </Text>
                </FullyCentered>

                {
                    !isLoading ? (
                        <Button
                            category='roundedBorded'
                            variant='secondary'
                            size='large'
                            marginTop={sizes.big}
                            type='submit'
                        >
                            {buttonText.confirm}
                        </Button>
                    ) : (<Loader />)
                }

                <Button
                    category='minimal'
                    variant='primary'
                    size='large'
                    marginTop={sizes.nano}
                    onClick={() => setStepRegister(step.back(stepRegister))}
                >
                    {buttonText.back}
                </Button>
            </StyledForm>
        </>
    )
};

export default RegisterStepThree; 